/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    fieldSpace: 2,
    outlineOffset: 8,
    outlineWidth: 1,
    showIcon: true,
    space: 2
  }
}
export default theme
